import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  useColorMode,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { NavbarWithCallToAction } from "../../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { getColor, getComponent } from "../../brandConfig";

const cheatsheets = [
  {
    title: "Phase 1 — Configured Business Builder Modules",
    description:
      "Visual diagram of 8 configured business builder modules and their required permissions for view, create, edit, and delete access.",
    path: "/cheatsheets/phase1-permissions",
    category: "Permissions",
  },
];

const CheatsheetIndex: React.FC = () => {
  const { colorMode } = useColorMode();
  const bgMain = getColor("background.main", colorMode);
  const textPrimary = getColor("text.primary", colorMode);
  const textSecondary = getColor("text.secondary", colorMode);

  return (
    <Box bg={bgMain} minHeight="100vh" display="flex" flexDirection="column">
      <NavbarWithCallToAction />

      <Container maxW="container.lg" py={10} flex="1">
        <VStack spacing={6} align="stretch">
          <Heading size="lg" color={textPrimary}>
            Cheatsheets
          </Heading>
          <Text color={textSecondary} fontSize="sm">
            Quick reference guides for the LinkOSx platform. Admin access
            required.
          </Text>

          <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
            {cheatsheets.map((sheet) => (
              <Box
                key={sheet.path}
                as={RouterLink}
                to={sheet.path}
                p={6}
                bg={getComponent("card", "bg", colorMode)}
                borderRadius="lg"
                border="1px solid"
                borderColor={getColor("border.light", colorMode)}
                boxShadow={getComponent("card", "shadow", colorMode)}
                _hover={{
                  boxShadow: getComponent("card", "hoverShadow", colorMode),
                  transform: "translateY(-2px)",
                  textDecoration: "none",
                }}
                transition="all 0.2s ease"
                cursor="pointer"
              >
                <VStack align="start" spacing={2}>
                  <Text
                    fontSize="xs"
                    fontWeight="600"
                    textTransform="uppercase"
                    color={getColor("secondary", colorMode)}
                    letterSpacing="wider"
                  >
                    {sheet.category}
                  </Text>
                  <Heading size="sm" color={textPrimary}>
                    {sheet.title}
                  </Heading>
                  <Text fontSize="sm" color={textSecondary}>
                    {sheet.description}
                  </Text>
                </VStack>
              </Box>
            ))}
          </SimpleGrid>
        </VStack>
      </Container>

      <FooterWithFourColumns />
    </Box>
  );
};

export default CheatsheetIndex;
